/**
 * ステータス: 未対応
 */
export const PROFESSIONAL_HOTLINE_STATUS_OPEN = {
    label: '未対応',
    value: 'OPEN',
};
/**
 * ステータス: 調整中
 */
export const PROFESSIONAL_HOTLINE_STATUS_SCHEDULING = {
    label: '調整中',
    value: 'SCHEDULING',
};
/**
 * ステータス: 相談予定
 */
export const PROFESSIONAL_HOTLINE_STATUS_SCHEDULED = {
    label: '相談予定',
    value: 'SCHEDULED',
};
/**
 * ステータス: 相談完了
 */
export const PROFESSIONAL_HOTLINE_STATUS_COMPLETED = {
    label: '相談完了',
    value: 'COMPLETED',
};
/**
 * ステータス: キャンセル
 */
export const PROFESSIONAL_HOTLINE_STATUS_CANCELED = {
    label: 'キャンセル',
    value: 'CANCELED',
};
/**
 * 匿名ホットライン開示ステータス一覧
 */
export const PROFESSIONAL_HOTLINE_STATUSES = [
    PROFESSIONAL_HOTLINE_STATUS_OPEN,
    PROFESSIONAL_HOTLINE_STATUS_SCHEDULING,
    PROFESSIONAL_HOTLINE_STATUS_SCHEDULED,
    PROFESSIONAL_HOTLINE_STATUS_COMPLETED,
    PROFESSIONAL_HOTLINE_STATUS_CANCELED,
];
